/**
 * Wraps `text` in a left-to-right bidi isolate (U+2066 LRI … U+2069 PDI).
 *
 * Numbers and technical values are not mirrored in an RTL (Arabic) line: "2,503 / 100,000",
 * "83%", "$7", "−$12", "30/09/26" each have to read as one left-to-right token. Without the
 * isolate the bidi algorithm reorders their parts ("100,000 / 2,503", "%83", "$12−"). The
 * marks Intl puts into Arabic dates and numbers (RLM, LRM, ALM) are dropped: inside the
 * token they would reorder its parts all over again. The isolate is invisible in a
 * left-to-right line.
 */
export const ltr = (text: string): string => `\u2066${text.replace(/[\u200e\u200f\u061c]/g, '')}\u2069`;
